import React from 'react'
import { CustomLink } from '@/components/atoms/CustomLink/CustomLink'
import { RelatedArticlesType } from './types'

export function RelatedArticles({ related_articles_title, related_articles }: RelatedArticlesType) {
  return (
    <section className="border-grey-100 border-t-1 border-b-1 mt-32 py-32 laptop:max-w-4xl laptop:mx-auto">
      <h4 className="font-bold mb-24 text-text-dark-900 text-bodyL font-mulish">{related_articles_title}</h4>
      {related_articles.length &&
        related_articles.map((link) => (
          <p className="mb-16 font-mulish" key={link._uid}>
            <CustomLink className="text-primary-500 font-bold text-bodyL" {...link} key={link._uid}>
              {link.text}
            </CustomLink>
          </p>
        ))}
    </section>
  )
}

export default RelatedArticles
